module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"startDate":"Başlangıç","endDate":"Bitiş","health":"Veri Kontrolü","file":"Fatura","lastUpdatedAt":"Son Değişiklik","date":"Tarih Aralığı","cost":"Tutar","paymentMethod":"Ödeme Tipi","dataType":"Veri Tipi","value":"Tüketim Miktarı"},"en":{"startDate":"Start Date","endDate":"End Date","health":"Data Health","date":"Date Range","file":"Bill","lastUpdatedAt":"Last Update","cost":"Cost","paymentMethod":"Payment Method","dataType":"Data Type","value":"Amount"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/components/CustomTable.vue
// module id = KPhV
// module chunks = 1